// user
export const DEFAUL_USER_TYPE = 'user';

// subUser
export const SUB_USER_TYPE = 'subUser';

// auth state
export const AUTH_TOKEN_STORAGE_KEY = 'auth_token';
export const AUTH_TOKEN = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || null;
export const INITIAL_USER_STATE = {};

// sub user state
export const SUB_USER_AUTH_TOKEN_STORAGKE_KEY = 'sub_user_auth_token';
export const SUB_USER_AUTH_TOKEN = localStorage.getItem(SUB_USER_AUTH_TOKEN_STORAGKE_KEY) || null;

// spotify auth state
export const SPOTIFY_ACCESS_TOKEN_STORAGE_KEY = 'access_token';
export const SPOTIFY_USER_ACCESS_TOKEN_STORAGE_KEY = 'user_access_token';

export const SPOTIFY_ACCESS_TOKEN = localStorage.getItem(SPOTIFY_ACCESS_TOKEN_STORAGE_KEY) || null;
export const SPOTIFY_USER_ACCESS_TOKEN = localStorage.getItem(
  SPOTIFY_USER_ACCESS_TOKEN_STORAGE_KEY,
)
  || null;
